<template>
	<div class="d-flex justify-content-between font-12 grey--text" v-bind:class="{ 'text--darken-1' : post.is_pinned }">
		<post-reaction-icons :post="post" />
		<div class="d-flex">
			<div v-if="post.comments_count">{{ post.comments_count }} {{ getCommentWord()  }}</div>
			<div v-if="post.shares" class="ml-2" :class="{'cursor-pointer': !simple}" @click="!simple ? showShares() : null">32 udostępień</div>
		</div>
		<v-dialog v-model="sharesDialog"
				@keydown.esc="hideShares()"
				v-on="sharesDialog ? { 'click:outside' : hideShares } : ''"
				persistent
				scrollable
				max-width="300">
			<v-card>lista osób które udostępniły</v-card>
		</v-dialog>

	</div>
</template>

<script>
import { wordSpelling } from '@/functions/wordSpelling'
import PostReactionIcons from "@/components/wall/post/PostReactionIcons";
export default {
	name: "PostDetails",
	components: {
		PostReactionIcons
	},
	props: {
		post: {
			type: Object,
			required: true
		},
		simple: {
			type: Boolean,
			default: false
		}
	},
	data () {
		return {
			sharesDialog: false,
			reactionsDialog: false,
		}
	},
	methods: {
		showShares: function () {
			this.sharesDialog = true
		},
		hideShares: function () {
			this.sharesDialog = false
		},
		showComments: function () {
			alert('pobranie komentarzy z API')
		},
		getCommentWord() {
			return wordSpelling('comment', this.post.comments_count)
		}
	}
}
</script>
